import {
  STATUS_TOGGLE,
  type CatalogProduct,
  type VendorProduct,
} from '../constants/vendor'

export function catalogProductName(
  catalog: CatalogProduct[],
  productId: string,
): string {
  return catalog.find((item) => item.id === productId)?.name ?? productId.slice(0, 8)
}

export function statusToggleLabel(name: string): string {
  return `${STATUS_TOGGLE} ${name}`
}

export function assignableCatalogProducts(
  catalog: CatalogProduct[],
  products: VendorProduct[],
): CatalogProduct[] {
  const assigned = new Set(products.map((item) => item.productId))
  return catalog.filter((item) => !assigned.has(item.id))
}

export function toggleProductId(ids: string[], productId: string): string[] {
  return ids.includes(productId)
    ? ids.filter((id) => id !== productId)
    : [...ids, productId]
}
